import React from 'react';
const ArabicLevel = (props) => {
    // console.log(props?.courses?.level_title?.level,"saaad");
    // console.log(props?.courses?.level_detail);
    let titles = props?.courses?.titles;
    let level_headings = props?.courses?.level_title;
    // if (accordionData) {
    //     innerSectionComponent = accordionData.map((item, index) => (<div className="inner-session" key={index}>
    //         <h2>{item?.session_title ?? null}</h2>
    //         <p>{item?.session_description ?? null}</p>
    //
    //         <ul>
    //             {
    //                 terms = item?.session_term?.map((term, index) => (
    //                     <div key={index}>
    //                         <li>
    //                             <img src={term?.term_image_url ?? null} alt="Flag Icon"></img><span>{term?.term_date  ?? null}</span>
    //                         </li>
    //                     </div>
    //                 ))
    //             }
    //         </ul>
    //         <table>
    //             <tr>
    //                 <th>{item?.session_headings?.title_heading ?? null}</th>
    //                 <th>{item?.session_headings?.instructor_heading ?? null}</th>
    //                 <th>{item?.session_headings?.format_heading ?? null}</th>
    //                 <th>{item?.session_headings?.in_person_dates_heading ?? null}</th>
    //                 <th>{item?.session_headings?.in_person_times_heading ?? null}</th>
    //             </tr>
    //             {item.session_detals.map((innerItem) => (
    //                 <tr>
    //                     <td>{innerItem?.title_detail ?? null}</td>
    //                     <td>{innerItem?.instructor_detail ?? null}</td>
    //                     <td>{innerItem?.format_detail ?? null}</td>
    //                     <td>{innerItem?.in_person_dates_detail ?? null}</td>
    //                     <td>{innerItem?.in_person_times_detail ?? null}</td>
    //                 </tr>
    //             ))}
    //         </table>
    //     </div>))
    // }
    let level_titles = titles.map((title) => (
            <p>{title?.title ?? null}</p>
    ))
    let level_rows = props?.courses?.level_detail.map((innerItem) => (
        <tr>
            <td>{innerItem?.level_desc ?? null}</td>
            <td>{innerItem?.req_book_des ?? null}</td>
            {/*<td>{innerItem?.meeting_inf ?? null}</td>*/}
            <td><div dangerouslySetInnerHTML={{ __html: innerItem?.meeting_inf ?? null }}></div></td>
            <td>{innerItem?.instructor_detail ?? null}</td>
        </tr>
    ))

    return ( 
        <div className='levels-offered' id='levels-offered'>
                        {/*<div className='levels-heading'>Courses offered this term</div>*/}
                        <div className='levels-heading'>{props?.courses?.heading ?? ''}</div>
                        <div className='semesters'>
                            {level_titles}
                            {/*<p>Arabic 1B (Beginning level / second of 2 semesters) </p>*/}
                            {/*<p>Arabic 2B (Intermediate level / second of 2 semesters)</p>*/}
                            {/*<p>Arabic 3B (Advanced level / second of 2 semesters)</p>*/}
                        </div>
                        <div className='desription'>
                        {/*<p>All levels are taught in a manner corresponding to typical US university academic Arabic programs, using the contemporary “communicative” approach, which develops the four skills areas of reading, writing, listening and speaking. Emphasis is given to classical (fus’ha) grammar and elements of modern standard Arabic, rather than any regional dialects. Proficiency in the language requires commitment and patience, and results can be seen over time.</p>*/}
                        {/*<p>{props?.courses?.description_b ?? ''}</p>*/}
                            <div dangerouslySetInnerHTML={{ __html: props?.courses?.description_b }}></div>
                        {/*<p>The coursework involves weekly self-paced preparation and homework using the assigned textbook and online platform, as well as one live online Zoom session per week with the instructor. Students are expected to come prepared for each live session, having completed the homework assignments, so learning can be reinforced through practice in the live setting.</p>*/}

                        </div>
                        <div className='levels-table'>
                            <table  style={{    minWidth: '720px'}} >
                                <tr>
                                    {/*<th>LEVEL</th>*/}
                                    {Object.keys(level_headings).slice(1).map((headings, i) => (
                                        <th>
                                            {level_headings[headings] ?? ''}
                                        </th>
                                    ))}
                                    {/*<th>{level_headings?.level || 'sasasa'}</th>*/}
                                    {/*<th>{level_headings?.req_book || 'sasasa'}</th>*/}
                                    {/*<th>{level_headings?.meeting_time || 'sasasa'}</th>*/}
                                    {/*<th>{level_headings?.instructor || 'sasasa'}</th>*/}

                                    {/*<th>REQUIRED BOOKS</th>*/}
                                    {/*<th>MEETING TIMES</th>*/}
                                    {/*<th>INSTRUCTORS</th>*/}
                                </tr>
                                {level_rows ?? ''}
                                {/*<tr>*/}
                                {/*    <td>ARABIC 1B</td>*/}
                                {/*    <td>Tuesday 5:00 - 8:00 pm PT</td>*/}
                                {/*    <td>al-kitaab fii ta'allum al-'arabiyya - Part 1(3rd ed. <br/>Purchase:<br/> <a href='https://www.vitalsource.com/products/al-kitaab-fii-tacallum-al-carabiyya-part-one-kristen-brustad-mahmoud-v9781626168145' target='_blank' >Geogetown eBook</a> <br/><a href='https://www.amazon.com/Al-Kitaab-fii-Tacallum-al-cArabiyya-Beginning/dp/1589017366/' target='_blank'> Amazon</a></td>*/}
                                {/*    <td>Dr. Mahbuba Hammad</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <td>ARABIC 2B</td>*/}
                                {/*    <td>Tuesday 5:00 - 8:00 pm PT</td>*/}
                                {/*    <td>al-kitaab fii ta'allum al-'arabiyya - Part 1(3rd ed.<br/> Purchase:<br/> <a href='https://www.vitalsource.com/products/al-kitaab-fii-tacallum-al-carabiyya-part-one-kristen-brustad-mahmoud-v9781626168145'target='_blank' >Geogetown eBook </a><br/><a href='https://www.amazon.com/Al-Kitaab-fii-Tacallum-al-cArabiyya-Beginning/dp/1589017366/' target='_blank' > Amazon</a></td>*/}
                                {/*    <td>Dr. Mahbuba Hammad</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <td>ARABIC 3B</td>*/}
                                {/*    <td>TBD based on enrollment</td>*/}
                                {/*    <td>al-kitaab fii ta'allum al-'arabiyya - Part 2(3rd ed. <br/>Purchase:<br/> <a href='https://www.vitalsource.com/products/al-kitaab-fii-tacallum-al-carabiyya-part-two-kristen-brustad-mahmoud-v9781626168169' target='_blank'>Geogetown eBook </a><br/> <a href='https://www.amazon.com/Al-Kitaab-Part-Two-Third-Bundle/dp/1626161232/' target='_blank'>Amazon</a></td>*/}
                                {/*    <td>Dr. Mahbuba Hammad</td>*/}
                                {/*</tr>*/}
                            </table>
                            </div>
                            {/*<p><b>Please purchase the required textbook at least one week prior to the course start date.</b> In addition to the textbook, access to the Al-Kitaab Companion website will need to be purchased for $25 (instructions will be provided by the instructor near the start of the course).</p>*/}
                            {/*<p>{props?.courses?.description_a ?? ''}</p>*/}
                            <div dangerouslySetInnerHTML={{ __html: props?.courses?.description_a }}></div>
                    </div>
     );
}

export default ArabicLevel; 